import {
  TypographyComponent,
  TypographySize,
} from '@vaad1st/component.atom.typography';
import classnames from 'classnames';
import styles from './article-card.component.module.less';

export interface ArticleCardProps {
  index?: number;
  imagePath: string;
  renditions?: {
    mobile?: string;
    tablet?: string;
    avif?: string;
    webp?: string;
  };
  lastUpdated: string;
  path: string;
  title: string;
  className?: string;
}

export default function ArticleCard(props: ArticleCardProps) {
  const {
    title,
    path,
    imagePath,
    renditions = {
      mobile: '',
      tablet: '',
      avif: '',
      webp: '',
    },
    className = '',
    index = 0,
  } = props;

  const imageRenditions = {
    url: imagePath,
    alt: '',
    renditions,
  };

  return (
    <a
      href={path}
      aria-label={title}
      className={classnames(styles['article-card'], className)}>
      <picture className={styles['article-card__background']}>
        {imageRenditions.renditions.avif && (
          <source srcSet={imageRenditions.renditions.avif} type="image/avif" />
        )}
        {imageRenditions.renditions.webp && (
          <source srcSet={imageRenditions.renditions.webp} type="image/webp" />
        )}
        {imageRenditions.renditions.mobile && (
          <source
            srcSet={imageRenditions.renditions.mobile}
            media="(max-width: 767px)"
          />
        )}
        {imageRenditions.renditions.tablet && (
          <source
            srcSet={imageRenditions.renditions.tablet}
            media="(max-width: 1280px)"
          />
        )}
        <img
          src={imagePath}
          alt={title}
          loading="lazy"
          className={styles['article-card__image']}
        />
        <span className={styles['article-card__sr-only']}>{title}</span>
      </picture>
      <article className={styles['article-card__content']} role="article">
        <div className={styles['article-card__title']}>
          <TypographyComponent as="h3" size={TypographySize.Xlg}>
            {title}
          </TypographyComponent>
        </div>
      </article>
    </a>
  );
}
